import { BrainSearchTitleFragment$key } from "@/brain-search/internal/__generated__/BrainSearchTitleFragment.graphql"
import { BrainSearchTitleRefetchQuery } from "@/brain-search/internal/__generated__/BrainSearchTitleRefetchQuery.graphql"
import Relay from "@/relay/relayUtils"
import { DiscoTextSkeleton } from "@disco-ui"
import { ReactNode } from "react"
import { useRefetchableFragment, useSubscribeToInvalidationState } from "react-relay"
import { graphql } from "relay-runtime"

interface BrainSearchTitleProps {
  brainSearchKey: BrainSearchTitleFragment$key
  skeleton?: ReactNode
}

function BrainSearchTitle({ brainSearchKey }: BrainSearchTitleProps): JSX.Element {
  const [brainSearch, refetch] = useRefetchableFragment<
    BrainSearchTitleRefetchQuery,
    BrainSearchTitleFragment$key
  >(
    graphql`
      fragment BrainSearchTitleFragment on BrainSearch
      @refetchable(queryName: "BrainSearchTitleRefetchQuery") {
        id
        title
      }
    `,
    brainSearchKey
  )

  // Subscribe to BrainSearch record invalidation to refetch only the title
  useSubscribeToInvalidationState([brainSearch.id], () => {
    refetch({}, { fetchPolicy: "network-only" })
  })

  return <>{brainSearch.title}</>
}

function BrainSearchTitleSkeleton({ skeleton }: { skeleton?: ReactNode }) {
  return <>{skeleton || <DiscoTextSkeleton variant={"body-sm-500"} width={120} />}</>
}

export default Relay.withSkeleton({
  component: BrainSearchTitle,
  skeleton: BrainSearchTitleSkeleton,
})
